import React from 'react';
import { ScheduleTable } from '../../components/ScheduleTable';
import { LocationBlock } from '../../components/LocationBlock';
export function LivoniaScheduleLocation() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-2422">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2423">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-2424">
          <div data-id="element-2425">
            <h2 className="text-4xl text-ink mb-8" data-id="element-2426">Class Times</h2>
            <ScheduleTable data-id="element-2427" />
          </div>
          <div data-id="element-2428">
            <h2 className="text-4xl text-ink mb-8" data-id="element-2429">Location Details</h2>
            <LocationBlock data-id="element-2430" />
          </div>
        </div>
      </div>
    </section>;
}